import { createAction, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import { useRedux } from 'util/hook/redux';

import { wrapFetch } from 'util/api';

export const getFilter = createAction('GET_FILTER', async () => {
	const { status, data } = await wrapFetch('product/filter');

	if (status !== 200) {
		return { data: {} };
	}

	return { data };
});

const reducer = {
	filter: handleActions(
		{
			GET_FILTER_PENDING: state => ({
				...state,
				loading: true,
			}),

			GET_FILTER_FULFILLED: (state, action) => ({
				...state,
				data: action.payload.data,
				loading: false,
			}),
		},
		{
			data: [],
			loading: false,
		},
	),
};

const selectFilter = createSelector(
	state => state.filter.data,
	data => ({ filter: data }),
);

export const useFilter = () => useRedux(selectFilter);

export const searchFilterName = (filterList, filterId) => {
	const result = filterList.filter(filter => filterId === filter.id);

	if (result.length !== 0) {
		return result[0].name;
	}

	return '';
};

export default { reducer };
